import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { thunk } from "redux-thunk";

import rootReducer from "./reducers";
import rootSaga from "./sagas";

//configuration du store redux
const sagaMiddleware = createSagaMiddleware();
const middlewares = [thunk, sagaMiddleware]; // <-- ajoute thunk AVANT saga
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export function configureStore(initialState) {
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );
  sagaMiddleware.run(rootSaga);
  return store;
}

export default configureStore();

//Creators : Florian Cohen-Joly / Thomas Castanier @3DDGAMES -- Under license